import React from 'react';
import {Outlet} from "react-router-dom";
import {AuthService} from "../../service/AuthService";
import {Forbidden} from "../../components/Forbidden";

export const Equipment = () => {
  return (
    <>
      { !AuthService.hasRole('ROLE_EQUIPEMENT') && (
        <Forbidden module="equipment"/>
      )}
      { AuthService.hasRole('ROLE_EQUIPEMENT') && (
        <Outlet/>
      )}
    </>
  );
}
